import { CampaignStatus } from "@/types/campaign/campaign-status/campaign-status";
import { Mission } from "@/types/mission/mission-type";
import { Objective } from "@/types/objective/objective-type";

export const calculateMissionStatus = (
    mission: Mission,
    isCompleted: boolean,
    isClaimed: boolean,
    isFirstPlace: boolean,
    ): CampaignStatus => {
    
    const now = Math.floor(Date.now() / 1000);
    const { end_date, start_date, objectives } = mission;
    const isExpiredMission = now > end_date;
    const isComingSoon = now < start_date;

    const hasExchangeObjective = objectives?.some((objective: Objective) =>
        objective.type?.includes("EXCHANGE")
    );
    const hasContestObjective = objectives?.some((objective: Objective) =>
        objective.type?.includes("CONTEST")
    );

    if (hasContestObjective) {
        if (isComingSoon) return "comingUp";
        if (isExpiredMission) {
        if (isFirstPlace) {
            if (isClaimed) return "completed";
            return "pending_claim";
        }
        return "expired";
        }
        if (isFirstPlace) return "incourseWinning";
        return "incourseLoosing";
    }

    if (hasExchangeObjective) {
        if (isComingSoon) return "comingUp";
        if (isExpiredMission) return "expired";
        if (isCompleted) return "completed";
        return "inCourse";
    }

    if (isComingSoon) return "comingUp";
    if (isExpiredMission) return "expired";
    if (isCompleted) {
        if (isClaimed) return "completed";
        return "pending_claim";
    }
    return "inCourse";
};